<template>
  <div class="form-group" v-if="render">
    <div v-if="previewSrc" class="signature-image">
      <img v-bind:src="previewSrc"><br>
    </div>
    <label :title="tooltip(element.label)">
      {{ t(element.label) }}
      <icons-render :propIcons="element.icons"/>
    </label>
    <canvas></canvas>
    <div class="float-right">
      <button
        @click="_clear"
        class="btn btn-default">
        {{ t('sgn_btn_clear') }}
      </button>
    </div>
  </div>
</template>

<script>
import SignaturePad from 'signature_pad'
import crc          from 'js-crc'
import IconsRender  from '../../templates/widgets/icons-render'
import FileLoader   from '../../../model/loader/file-loader'
import DictionaryLoader         from '@/model/loader/dictionary-loader'

export default {
  name:       'Signature',
  components: {
    IconsRender
  },
  props:      {
    element:  {
      required: true,
      type:     Object,
      default:  () => {
        return {
          name:     null,
          type:     null,
          dataType: null,
          label:    null
        }
      }
    },
    defaults: {
      type:    Object,
      default: null
    }
  },

  data () {
    return {
      file:         {},
      signaturePad: undefined,
      previewSrc:   null,
      render:       true
    }
  },

  created () {
    if (!this.defaults.hasOwnProperty('ID')) {
      return
    }

    this.previewSrc = FileLoader
      .fileGUID(this.defaults.FILEGUID)
      .size('M')
      .downloadUrl(
        this.$store.getters.urlAppName,
        this.defaults.FILENAME,
        this.defaults.FILEYEAR,
        this.defaults.FILEEXTENSION)
  },

  mounted () {
    let canvas = document.querySelector('canvas')

    this.signaturePad = new SignaturePad(canvas, {
      onEnd: () => {
        this._change()
      }
    })

    this._resizeCanvas(canvas)
  },

  methods: {

    /**
     *
     * @param canvas
     * @private
     */
    _resizeCanvas (canvas) {
      let ratio     = window.devicePixelRatio || 1
      canvas.width  = canvas.offsetWidth * ratio
      canvas.height = canvas.offsetHeight * ratio
      canvas.getContext('2d').scale(ratio, ratio)
    },

    /**
     *
     * @param e Event
     * @private
     */
    _change (e) {
      let _crc = crc.crc32,
          data = this.signaturePad.toDataURL()

      this.file[this.element.document.dataKey]      = data
      this.file[this.element.document.dataFileName] = _crc(data) + '.png'

      this.$emit('changeValue', { element: this.element, value: this.file })
    },

    /**
     *
     * @private
     */
    _clear () {
      this.signaturePad.clear()
    },

    setRender (render) {
      this.render = render
    },

    tooltip (key) {
      return DictionaryLoader.tooltip(key, this.$user.languageCode)
    }
  }

}
</script>

<style scoped>
canvas {
  width: 100%;
  min-height: 300px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.27), 0 0 40px rgba(0, 0, 0, 0.08) inset;
  border-radius: 3px;
  cursor: crosshair;
}

.signature-image {
  background: #f1f4f5;
  width: fit-content;
}
</style>
